import { environment } from 'src/environments/environment';

const PROD_INVITE_BASE = 'https://i.picaggo.com/';

/**
 * Prod always gets i.picaggo.com, whatever the build config says — a test
 * build deployed to events.picaggo.com by mistake must not send real guests to
 * the test site.
 */
const inviteLinkBase = window.location.hostname === 'events.picaggo.com'
  ? PROD_INVITE_BASE
  : environment.inviteLinkBase;

/**
 * The shareable invite link for an event code (collaborator hash or viewer
 * hash). Prod hands out i.picaggo.com/{code}; the test build hands out
 * app.picaggo.com/{code} so a guest lands back on the test site, not prod.
 */
export function inviteLinkFor(code: string | null | undefined): string {
  return inviteLinkBase + code;
}

/**
 * The server's cached QR images (web_qrCode, web_viewer_qrCode) always encode
 * i.picaggo.com/{code}. Only pair one with our link when ours is that same URL;
 * otherwise draw the code here so the QR goes where the link goes.
 */
export const serverQrMatchesInviteLink = inviteLinkBase === PROD_INVITE_BASE;
